import EpxAsthmaTable from '../../components/organisms/table/session/apps/epxasthma';
import EpxAsthmaForm from '../../components/organisms/schedule/forms/epxasthma';
import EpxAsthmaSettings from '../../components/organisms/schedule/settings/epxasthma';
import EpxAsthmaGraph from '../../components/organisms/graph/apps/epxasthma';

import EpxBasicNeedsTable from '../../components/organisms/table/session/apps/epxbasicneeds';
import EpxBasicNeedsForm from '../../components/organisms/schedule/forms/epxbasicneeds';

import EpxBFMgmtTable from '../../components/organisms/table/session/apps/epxbfmgmt';
import EpxBFMgmtForm from '../../components/organisms/schedule/forms/epxbfmgmt';

import EpxBreastfeedTable from '../../components/organisms/table/session/apps/epxbreastfeed';
import EpxBreastfeedForm from '../../components/organisms/schedule/forms/epxbreastfeed';
import EpxBreastfeedGraph from '../../components/organisms/graph/apps/epxbreastfeed';

import EpxCaregiverTable from '../../components/organisms/table/session/apps/epxcaregiver';
import EpxCaregiverForm from '../../components/organisms/schedule/forms/epxcaregiver';

import EpxCOPDTable from '../../components/organisms/table/session/apps/epxcopd';
import EpxCOPDForm from '../../components/organisms/schedule/forms/epxcopd';
import EpxCOPDSettings from '../../components/organisms/schedule/settings/epxcopd';
import EpxCOPDGraph from '../../components/organisms/graph/apps/epxcopd';
import { EpxCOPDConfigForm } from '../../components/organisms/config/apps/epxcopd';

import EpxDepressTable, {
  EpxDepressGADTable,
  EpxDepressPHQTable,
  EpxDepressPHQ2Table,
  EpxDepressPHQ2ToPHQ9Table,
  EpxDepressCOVIDTable,
  EpxDepressSuicideConnectTable
} from '../../components/organisms/table/session/apps/epxdepress';
import EpxDepressForm from '../../components/organisms/schedule/forms/epxdepress';
import EpxDepressSettings from '../../components/organisms/schedule/settings/epxdepress';
import EpxDepressGraph from '../../components/organisms/graph/apps/epxdepress';

import EpxDiabetesForm from '../../components/organisms/schedule/forms/epxdiabetes';
import EpxDiabetesSettings from '../../components/organisms/schedule/settings/epxdiabetes';
import EpxDiabetesTable from '../../components/organisms/table/session/apps/epxdiabetes';
import EpxDiabetesGraph from '../../components/organisms/graph/apps/epxdiabetes';
import EpxDiabetesSummary from '../../components/organisms/summary/apps/epxdiabetes';
import { EpxDiabetesConfigForm } from '../../components/organisms/config/apps/epxdiabetes';

import EpxPreDiabetesForm from '../../components/organisms/schedule/forms/epxprediabetes';
import EpxPreDiabetesSettings from '../../components/organisms/schedule/settings/epxprediabetes';
import EpxPreDiabetesTable from '../../components/organisms/table/session/apps/epxprediabetes';
import { EpxPreDiabetesConfigForm } from '../../components/organisms/config/apps/epxprediabetes';

import EpxDialysisTable from '../../components/organisms/table/session/apps/epxdialysis';
import EpxDialysisForm from '../../components/organisms/schedule/forms/epxdialysis';

import EpxDischargeTable from '../../components/organisms/table/session/apps/epxdischarge';
import EpxDischargeForm from '../../components/organisms/schedule/forms/epxdischarge';

import EpxEndodbTable from '../../components/organisms/table/session/apps/epxendodb';
import EpxEndodbGraph from '../../components/organisms/graph/apps/epxendodb';
import EpxEndodbForm from '../../components/organisms/schedule/forms/epxendodb';
import EpxEndodbSettings from '../../components/organisms/schedule/settings/epxendodb';
import EpxEndodbSummary from '../../components/organisms/summary/apps/epxendodb';

import EpxFallRiskTable from '../../components/organisms/table/session/apps/epxfallrisk';
import EpxFallRiskGraph from '../../components/organisms/graph/apps/epxfallrisk';
import EpxFallRiskForm from '../../components/organisms/schedule/forms/epxfallrisk';

import EpxGenericTable from '../../components/organisms/table/session/apps/epxgeneric';
import EpxGenericForm from '../../components/organisms/schedule/forms/epxgeneric';
import EpxGenericSettings from '../../components/organisms/schedule/settings/epxgeneric';

import EpxHeartTable from '../../components/organisms/table/session/apps/epxheart';
import EpxHeartForm from '../../components/organisms/schedule/forms/epxheart';
import EpxHeartSettings from '../../components/organisms/schedule/settings/epxheart';
import EpxHeartGraph from '../../components/organisms/graph/apps/epxheart';
import { EpxHeartConfigForm } from '../../components/organisms/config/apps/epxheart';

import EpxHyperTable from '../../components/organisms/table/session/apps/epxhyper';
import EpxHyperForm from '../../components/organisms/schedule/forms/epxhyper';
import EpxHyperSettings from '../../components/organisms/schedule/settings/epxhyper';
import EpxHyperGraph from '../../components/organisms/graph/apps/epxhyper';
import EpxHyperSummary from '../../components/organisms/summary/apps/epxhyper';
import { EpxHyperConfigForm } from '../../components/organisms/config/apps/epxhyper';

import EpxMedCompTable from '../../components/organisms/table/session/apps/epxmedcomp';
import EpxMedCompForm from '../../components/organisms/schedule/forms/epxmedcomp';

import EpxOpioidMgmtTable from '../../components/organisms/table/session/apps/epxopioidmgmt';
import EpxOpioidMgmtGraph from '../../components/organisms/graph/apps/epxopioidmgmt';

import EpxPedOncTable from '../../components/organisms/table/session/apps/epxpedonc';
import EpxPedOncForm from '../../components/organisms/schedule/forms/epxpedonc';
import EpxPedOncSettings from '../../components/organisms/schedule/settings/epxpedonc';

import EpxPPDepressTable from '../../components/organisms/table/session/apps/epxppdepress';
import EpxPPDepressForm from '../../components/organisms/schedule/forms/epxppdepress';
import EpxPPDepressSummary from '../../components/organisms/summary/apps/epxppdepress';

import EpxReferTable from '../../components/organisms/table/session/apps/epxrefer';

import EpxSDOHTable from '../../components/organisms/table/session/apps/epxsdoh';
import EpxSDOHForm from '../../components/organisms/schedule/forms/epxsdoh';

import EpxSubAbuseTable from '../../components/organisms/table/session/apps/epxsubabuse';
import EpxSubAbuseForm from '../../components/organisms/schedule/forms/epxsubabuse';
import EpxSubAbuseGraph from '../../components/organisms/graph/apps/epxsubabuse';
import EpxSubAbuseSettings from '../../components/organisms/schedule/settings/epxsubabuse';

import EpxSurgeryTable from '../../components/organisms/table/session/apps/epxsurgery';
import EpxSurgeryForm from '../../components/organisms/schedule/forms/epxsurgery';
import { EpxSurgeryConfigForm } from '../../components/organisms/config/apps/epxsurgery';

import EpxVitalsTable from '../../components/organisms/table/session/apps/epxvitals';
import EpxVitalsForm from '../../components/organisms/schedule/forms/epxvitals';
import EpxVitalsSettings from '../../components/organisms/schedule/settings/epxvitals';

import EpxWellMgmtTable from '../../components/organisms/table/session/apps/epxwellmgmt';
import EpxWellMgmtSettings from '../../components/organisms/schedule/settings/epxwellmgmt';
import EpxWellMgmtForm from '../../components/organisms/schedule/forms/epxwellmgmt';

import EpxWellnessTable from '../../components/organisms/table/session/apps/epxwellness';

import EpxOncologyForm from '../../components/organisms/schedule/forms/epxoncology';
import EpxOncologyTable, {
  EpxOncologyQOLTable,
  EpxOncologyHRSNTable
} from '../../components/organisms/table/session/apps/epxoncology';

import EpxAsthmaYZForm from '../../components/organisms/schedule/forms/epxasthmayz';
import EpxAsthmaYZSettings from '../../components/organisms/schedule/settings/epxasthmayz';
import EpxAsthmaYZTable, {
  ACTLessThanTwelveTable,
  ACTGreaterThanTwelveTable
} from '../../components/organisms/table/session/apps/epxasthmayz';

import EpxDischargeHTForm from '../../components/organisms/schedule/forms/epxdischargeht';
import EpxDischargeHTSettings from '../../components/organisms/schedule/settings/epxdischargeht';
import EpxDischargeHTTable from '../../components/organisms/table/session/apps/epxdischargeht';
import { EpxDischargeHTConfigForm } from '../../components/organisms/config/apps/epxdischargeht';

import SurveyQualTable from '../../components/organisms/table/session/apps/surveyqual';

import { ProcessSchedule as EpxAsthmaProcessSchedule } from './epxasthma';
import { ProcessSchedule as EpxCOPDProcessSchedule } from './epxcopd';
import { ProcessSchedule as EpxDepressProcessSchedule } from './epxdepress';
import { ProcessSchedule as EpxSurgeryProcessSchedule } from './epxsurgery';

import { AppKey, AppConfig } from '.';
import GenericForm from '../../components/organisms/schedule/forms/generic';
import GenericSettings from '../../components/organisms/schedule/settings/generic';
import GenericTable from '../../components/organisms/table/session/apps/generic';
import { GenericConfigForm } from '../../components/organisms/config/apps/generic';

// Entries

const EpxAsthma = {
  key: 'epxasthma',
  processSchedule: EpxAsthmaProcessSchedule,
  form: EpxAsthmaForm,
  settings: EpxAsthmaSettings,
  table: EpxAsthmaTable,
  graph: EpxAsthmaGraph
};

const EpxBasicNeeds = {
  key: 'epxbasicneeds',
  form: EpxBasicNeedsForm,
  table: EpxBasicNeedsTable
};

const EpxBFMgmt = {
  key: 'epxbfmgmt',
  form: EpxBFMgmtForm,
  table: EpxBFMgmtTable
};

const EpxBreastfeed = {
  key: 'epxbreastfeed',
  form: EpxBreastfeedForm,
  table: EpxBreastfeedTable,
  graph: EpxBreastfeedGraph
};

const EpxCaregiver = {
  key: 'epxcaregiver',
  form: EpxCaregiverForm,
  table: EpxCaregiverTable
};

const EpxCOPD: AppConfig = {
  key: 'epxcopd',
  processSchedule: EpxCOPDProcessSchedule,
  form: EpxCOPDForm,
  settings: EpxCOPDSettings,
  table: EpxCOPDTable,
  graph: EpxCOPDGraph,
  config: EpxCOPDConfigForm
};

const EpxDepress = {
  key: 'epxdepress',
  processSchedule: EpxDepressProcessSchedule,
  form: EpxDepressForm,
  settings: EpxDepressSettings,
  table: EpxDepressTable,
  extraTables: {
    suicide: {
      label: 'Hotline Connection',
      table: EpxDepressSuicideConnectTable
    },
    phq2: {
      label: 'PHQ-2',
      table: EpxDepressPHQ2Table,
      visible: (schedule) => schedule?.isPHQScreening === true
    },
    phq2_to_phq9: {
      label: 'PHQ-2 \u2192 PHQ-9',
      table: EpxDepressPHQ2ToPHQ9Table,
      visible: (schedule) => schedule?.isPHQScreening === true
    },
    phq: {
      label: 'PHQ-9',
      table: EpxDepressPHQTable
    },
    gad: {
      label: 'GAD-7',
      table: EpxDepressGADTable
    },
    covid: {
      label: 'COVID BH',
      table: EpxDepressCOVIDTable
    }
  },
  graph: EpxDepressGraph
};

const EpxDialysis = {
  key: 'epxdialysis',
  table: EpxDialysisTable,
  form: EpxDialysisForm
};

const EpxDiabetes = {
  key: 'epxdiabetes',
  form: EpxDiabetesForm,
  settings: EpxDiabetesSettings,
  summary: EpxDiabetesSummary,
  table: EpxDiabetesTable,
  graph: EpxDiabetesGraph,
  config: EpxDiabetesConfigForm
};

const EpxDischarge = {
  key: 'epxdischarge',
  form: EpxDischargeForm,
  table: EpxDischargeTable
};

const EpxEndodb = {
  key: 'epxendodb',
  form: EpxEndodbForm,
  settings: EpxEndodbSettings,
  table: EpxEndodbTable,
  graph: EpxEndodbGraph,
  summary: EpxEndodbSummary
};

const EpxFallRisk = {
  key: 'epxfallrisk',
  form: EpxFallRiskForm,
  table: EpxFallRiskTable,
  graph: EpxFallRiskGraph
};

const EpxGeneric = {
  key: 'epxgeneric',
  form: EpxGenericForm,
  settings: EpxGenericSettings,
  table: EpxGenericTable
};

const EpxHeart = {
  key: 'epxheart',
  form: EpxHeartForm,
  settings: EpxHeartSettings,
  table: EpxHeartTable,
  graph: EpxHeartGraph,
  config: EpxHeartConfigForm
};

const EpxHyper = {
  key: 'epxhyper',
  form: EpxHyperForm,
  settings: EpxHyperSettings,
  table: EpxHyperTable,
  graph: EpxHyperGraph,
  summary: EpxHyperSummary,
  config: EpxHyperConfigForm
};

const EpxMedComp = {
  key: 'epxmedcomp',
  form: EpxMedCompForm,
  table: EpxMedCompTable
};

const EpxOncology = {
  key: 'epxoncology',
  form: EpxOncologyForm,
  table: EpxOncologyTable,
  extraTables: {
    qol: {
      label: 'QOL',
      table: EpxOncologyQOLTable
    },
    hrsn: {
      label: 'HRSN',
      table: EpxOncologyHRSNTable
    }
  }
};

const EpxOpioidMgmt = {
  key: 'epxopioidmgmt',
  table: EpxOpioidMgmtTable,
  graph: EpxOpioidMgmtGraph
};

const EpxPedOnc = {
  key: 'epxpedonc',
  table: EpxPedOncTable,
  form: EpxPedOncForm,
  settings: EpxPedOncSettings
};

const EpxPPDepress = {
  key: 'epxppdepress',
  form: EpxPPDepressForm,
  table: EpxPPDepressTable,
  summary: EpxPPDepressSummary
};

const EpxRefer = {
  key: 'epxrefer',
  table: EpxReferTable
};

const EpxSDOH = {
  key: 'epxsdoh',
  table: EpxSDOHTable,
  form: EpxSDOHForm
};

const EpxSubAbuse = {
  key: 'epxsubabuse',
  form: EpxSubAbuseForm,
  settings: EpxSubAbuseSettings,
  table: EpxSubAbuseTable,
  graph: EpxSubAbuseGraph
};

const EpxSurgery = {
  key: 'epxsurgery',
  table: EpxSurgeryTable,
  form: EpxSurgeryForm,
  config: EpxSurgeryConfigForm,
  processSchedule: EpxSurgeryProcessSchedule,
  shouldSkipDefaultProcess: false
};

const EpxVitals = {
  key: 'epxvitals',
  form: EpxVitalsForm,
  settings: EpxVitalsSettings,
  table: EpxVitalsTable
};

const EpxWellMgmt = {
  key: 'epxwellmgmt',
  table: EpxWellMgmtTable,
  form: EpxWellMgmtForm,
  settings: EpxWellMgmtSettings
};

const EpxWellness = {
  key: 'epxwellness',
  table: EpxWellnessTable
};

const EpxAsthmaYZ = {
  key: 'epxasthmayz',
  form: EpxAsthmaYZForm,
  settings: EpxAsthmaYZSettings,
  table: EpxAsthmaYZTable,
  extraTables: {
    ACTLessThanTwelve: {
      label: 'ACT < 12',
      table: ACTLessThanTwelveTable
    },
    ACTGreaterThanTwelve: {
      label: 'ACT > 12',
      table: ACTGreaterThanTwelveTable
    }
  }
};

const QualitySurvey = {
  key: 'surveyqual',
  table: SurveyQualTable
};

const EpxDischargeHT = {
  key: 'epxdischargeht',
  form: EpxDischargeHTForm,
  settings: EpxDischargeHTSettings,
  table: EpxDischargeHTTable,
  config: EpxDischargeHTConfigForm
};

const EpxPreDiabetes = {
  key: 'epxprediabetes',
  form: EpxPreDiabetesForm,
  settings: EpxPreDiabetesSettings,
  table: EpxPreDiabetesTable,
  config: EpxPreDiabetesConfigForm
};

const Generic = {
  key: 'composer',
  form: GenericForm,
  settings: GenericSettings,
  table: GenericTable,
  config: GenericConfigForm
};

type AppConfigs = {
  [key in AppKey]?: AppConfig;
};

const Config = {
  epxasthma: EpxAsthma,
  epxbasicneeds: EpxBasicNeeds,
  epxbfmgmt: EpxBFMgmt,
  epxbreastfeed: EpxBreastfeed,
  epxcaregiver: EpxCaregiver,
  epxcopd: EpxCOPD,
  epxdepress: EpxDepress,
  epxdialysis: EpxDialysis,
  epxdiabetes: EpxDiabetes,
  epxdischarge: EpxDischarge,
  epxendodb: EpxEndodb,
  epxfallrisk: EpxFallRisk,
  epxgeneric: EpxGeneric,
  epxheart: EpxHeart,
  epxhyper: EpxHyper,
  epxmedcomp: EpxMedComp,
  epxopioidmgmt: EpxOpioidMgmt,
  epxpedonc: EpxPedOnc,
  epxppdepress: EpxPPDepress,
  epxrefer: EpxRefer,
  epxsdoh: EpxSDOH,
  epxsubabuse: EpxSubAbuse,
  epxsurgery: EpxSurgery,
  epxvitals: EpxVitals,
  epxwellmgmt: EpxWellMgmt,
  epxwellness: EpxWellness,
  epxoncology: EpxOncology,
  epxasthmayz: EpxAsthmaYZ,
  epxdischargeht: EpxDischargeHT,
  surveyqual: QualitySurvey,
  epxprediabetes: EpxPreDiabetes,
  generic: Generic
};

export default Config as AppConfigs;
